import { Collapse, List, ListItem, ListItemText, Theme } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import { Fragment, memo, ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useCallback } from 'react';
import { DisabledCancellationAireCardMenu } from 'shell/view-models/disabled-menu';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nested: {
      paddingLeft: `${theme.spacing(4)} !important`,
    },
    nestedIcon: {
      minWidth: 'auto !important',
      paddingRight: theme.spacing(2),
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
    colorItems: {
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
  })
);

interface CardCollapseProps {
  onSubItemClick?: () => void;
  link: string;
  active: DisabledCancellationAireCardMenu;
}

const CardCollapseComponent = ({
  onSubItemClick,
  link,
  active,
}: CardCollapseProps): ReactElement => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  return (
    <Fragment>
      <ListItem
        button
        key="CancellazioneAire"
        onClick={() => {
          handleClick();
        }}
        sx={{ pl: 6 }}
        className={classes.colorItems}
      >
        <ListItemText className={classes.colorItems} primary="Cancellazione AIRE " />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {active.perditaCittadinanza ? (
            <Link
              key={`${link}/cancellazione-aire/perdita-cittadinanza`}
              to={`${link}/cancellazione-aire/perdita-cittadinanza`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText
                  className={classes.colorItems}
                  primary="Perdita Cittadinanza Italiana"
                />
              </ListItem>
            </Link>
          ) : undefined}
          {active.irreperibilitaPresunta ? (
            <Link
              key={`${link}/cancellazione-aire/irreperibilita-presunta`}
              to={`${link}/cancellazione-aire/irreperibilita-presunta`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Irreperibilità Presunta" />
              </ListItem>
            </Link>
          ) : undefined}
        </List>
      </Collapse>
    </Fragment>
  );
};

CardCollapseComponent.displayName = 'Card Collapse Item';

const CardCollapse = memo(CardCollapseComponent);

export default CardCollapse;
